// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"Ti","flipped":"Ui","mainContentContainer":"Vi","cta":"Wi","mainContentCtaDefault":"Xi","disabled":"Yi","mainContentCtaWhite":"Zi"};